import React, { useState } from 'react';
import Section from './../../Section/Section';
import './TryOnPDP.scss';
import ButtonOwnDays from '../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';
import OdPdpTryOn from '../../../../static/assets/img/pdp/od-pdp-try-on.png';
import { useSelector } from 'react-redux';
import LKModal from './../../../desktop/components/Modal/Modal';

const TryOnPDP = ({ glassOnUrl = '' }) => {
  const dataLocale = useSelector(state => state.locale);
  const productID = useSelector(state => state.common.productID);
  const {
    TRY_ON_VIRTUALLY = 'Try on virtually',
    TRY_ON_THIS_FRAME_RIGHT_NOW = 'Try on this frame right now',
  } = dataLocale;

  const [showTryOnPopUp, setShowTryOnPopUp] = useState(false);

  const closeTryOn = () => {
    setShowTryOnPopUp(false);
  };

  return (
    <Section style={{ marginBottom: 0 }}>
      <div className="od-try-on-pdp">
        <div className="od-try-on-pdp__left">
          <div className="od-try-on-pdp__title od-font-reg">{TRY_ON_THIS_FRAME_RIGHT_NOW}</div>
          <ButtonOwnDays
            fontClass="od-font-bold"
            fontSize="16px"
            mode="white-7"
            px="50px"
            py="12px"
            text={TRY_ON_VIRTUALLY}
            onClick={() => setShowTryOnPopUp(true)}
          />
        </div>
        <div className="od-try-on-pdp__right">
          <img
            alt="try on faces"
            className="od-try-on-pdp__image"
            src={OdPdpTryOn}
            onClick={() => setShowTryOnPopUp(true)}
          />
        </div>
        {showTryOnPopUp && (
          <LKModal
            backdrop
            keyboard
            dialogClassName="od-container-modals"
            hideHandler={() => setShowTryOnPopUp(false)}
            showModal={showTryOnPopUp}
            size="large"
          >
            <span className="od-modal-close" onClick={closeTryOn}>
              ×
            </span>
            <iframe allowfullscreen allow="camera" src={glassOnUrl} title="owndays try on"></iframe>
          </LKModal>
        )}
      </div>
    </Section>
  );
};

export default TryOnPDP;
